/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * My App
 * This is an awesome app!
 * OpenAPI spec version: 1.0.0
 */

/**
 * The type of assignment
 */
export enum CreateAssignmentDTOType {
  fixed= 'fixed',
  variable= 'variable',

}